import { useEffect, useState } from "react";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Row, Col, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setAllDepartments } from "../../redux/actions/mainAction";
import noitem from "../../images/noitem.gif";

const { confirm } = Modal;

const DepartmentsTable = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { GlobalResponse } = useSelector((state) => state);
  const { MainResponse } = useSelector((state) => state);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    getDepartments(page);
  }, [GlobalResponse.triggeranyevent, page]);

  const getDepartments = async (page) => {
    try {
      let result = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/get-departments/?page=${page}`,
        {
          headers: {
            authorization: `bearer ${JSON.parse(
              localStorage.getItem("token")
            )} `,
          },
        }
      );
      result = await result.json();
      dispatch(setAllDepartments(result.departments));
      setTotalPages(result.totalPages);
    } catch (error) {}
  };

  const showDeleteConfirm = (departmentName, _id, employeeCount) => {
    if (employeeCount < 1) {
      confirm({
        centered: "centered",
        title: departmentName,
        icon: <ExclamationCircleFilled />,
        content: "Şöbəni silmək istədiyinizdən əminsiniz?",
        okText: "Sil",
        okType: "danger",
        cancelText: "İmtina Et",
        onOk() {
          deleteDepartment(_id);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    } else {
      confirm({
        centered: "centered",
        title: departmentName + " silinə bilməz!",
        icon: <ExclamationCircleFilled />,
        content:
          "Bu şöbəni silmək üçün əvvəlcə şöbədə çalışan əməkdaşları silmək lazımdır!",
        okText: "Oldu",
        okType: "danger",
        cancelText: "Əməkdaşlar",
        onOk() {},
        onCancel() {
          navigate("/employees");
        },
      });
    }
  };

  const deleteDepartment = async (_id) => {
    let result = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/department/${_id}`,
      {
        method: "delete",
        headers: {
          authorization: `bearer ${JSON.parse(localStorage.getItem("token"))} `,
        },
      }
    );
    result = await result.json();
    console.log(result);
    if (result) {
      getDepartments();
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <>
      {MainResponse.allDepartments.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>#</th>
              <th>Şöbənin Adı</th>
              <th>Şirkət</th>
              <th>Əməkdaş Sayı</th>
              <th>Əməliyyat</th>
            </tr>
          </thead>
          {MainResponse.allDepartments.map((department, index) => (
            <tbody key={department._id}>
              <tr>
                <td>{department._id}</td>
                <td>{department.departmentName}</td>
                <td>{department.companyName}</td>
                <td>{department.employeeCount}</td>

                <td>
                  <Link
                    state={{ id: department._id }}
                    className="btn"
                    to="/departmentedit"
                  >
                    {<BiEdit />}
                  </Link>

                  <Link
                    onClick={() =>
                      showDeleteConfirm(
                        department.departmentName,
                        department._id,
                        department.employeeCount
                      )
                    }
                    className="btn-del"
                  >
                    {<AiFillDelete />}
                  </Link>
                </td>
              </tr>
            </tbody>
          ))}
        </table>
      ) : (
        <div className="no-item">
          <Row>
            <Col span={24}>
              <div className="no-item">
                <img style={{ width: "342px" }} src={noitem} alt="noitem" />
              </div>
            </Col>
          </Row>
        </div>
      )}

      {totalPages > 0 && (
        <div className="pagination">
          <button
            disabled={page === 1}
            onClick={() => handlePageChange(page - 1)}
          >
            Əvvəlki
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              className={page === index + 1 ? "active" : ""}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button
            disabled={page === totalPages}
            onClick={() => handlePageChange(page + 1)}
          >
            Növbəti
          </button>
        </div>
      )}
    </>
  );
};

export default DepartmentsTable;
